import { render, staticRenderFns } from "./BinFormHeader.vue?vue&type=template&id=c9a871c2&lang=pug"
import script from "./BinFormHeader.vue?vue&type=script&lang=js"
export * from "./BinFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports